import { selectSaturatedTree, TreeNodeOrNodeSlug } from 'react-common'
import { useSelector } from 'react-redux'

export const useHasAccessToPortal = () => {
  const hamburgerTree = useSelector(selectSaturatedTree) as Map<string, TreeNodeOrNodeSlug>

  return hamburgerTree?.size > 0
}
